<template>
  <v-container fluid>
    <div>
      <div class="error" v-if="error">
        <p>{{ error }}</p>
      </div>

      <div class="field">
        <InputField
          v-model="form.firstName"
          :labelTitle="$t('dash.patient.create.form-firstname')"
          required
          :placeholder="$t('dash.patient.create.form-firstname')"
          margin="25px auto"
          ref="firstName"
        ></InputField>

        <InputField
          v-model="form.lastName"
          :labelTitle="$t('dash.patient.create.form-lastname')"
          required
          :placeholder="$t('dash.patient.create.form-lastname')"
          margin="0 auto 25px auto"
        ></InputField>

        <InputField
          v-if="!patient"
          v-model="form.birthday"
          :labelTitle="$t('dash.patient.create.form-date')"
          required
          :maxDate="new Date().toISOString().split('T')[0]"
          type="date"
          margin="25px auto"
          ref="firstName"
        ></InputField>

        <InputField
          v-model="form.crib"
          :labelTitle="$t('dash.patient.create.form-crib')"
          type="text"
          :placeholder="$t('dash.patient.create.form-crib')"
          required
          margin="0 auto 25px auto"
        ></InputField>

        <div style="text-align: left; color: red; padding-left: 90px; display: block" v-if="errorWeight">
          <p class="">{{ errorWeight }}</p>
        </div>
        <InputField
          v-if="!patient"
          v-model="form.weight"
          :labelTitle="$t('dash.patient.create.form-weight')"
          step="any"
          type="number"
          :placeholder="0"
          unit="g"
          margin="0 auto 25px auto"
        ></InputField>

        <div style="text-align: left; color: red; padding-left: 70px; display: block" v-if="errorLength">
          <p class="">{{ errorLength }}</p>
        </div>
        <InputField
          v-if="!patient"
          v-model="form.length"
          :labelTitle="$t('dash.patient.create.form-length')"
          type="number"
          unit="cm"
          :placeholder="0"
          margin="0 auto 25px auto"
        ></InputField>

        <div class="locale-select">
          <p>{{ $t("dash.patient.create.form-language") }}:</p>
          <ul class="locale-radio">
            <li v-for="locale in getAllSupportedLocales()" :key="locale">
              <label :for="locale" class="checkbox-container">
                {{ $t(`general.languages.${locale}`) }}
                <input
                  type="checkbox"
                  :id="locale"
                  :value="locale"
                  v-model="form.selectedLocales"
                />
                <span class="checkmark"></span>
              </label>
            </li>
          </ul>
        </div>

        <LoadingButton v-if="loading"></LoadingButton>
        <div v-else>
          <Button
            v-if="!patient"
            type="submit"
            width="200"
            title="Toevoegen"
            style="margin: 16px 0"
            @click.native="writePatient('add')"
          ></Button>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import {neoparentPatients, neoparentPosts} from "@/api";
import { getSupportedLocales } from "@/helpers";

export default {
  props: ["nurseId"],
  name: "neoparent-create-patient-epd",
  computed: {
    requiredFieldsFilledIn(){
      if (!this.form.firstName)
        return false
      if (!this.form.lastName)
        return false
      if (!this.form.birthday)
        return false
      if (!this.form.crib)
        return false

      return true
    },
    errorWeight(){
      if (this.form.weight) {
        if (this.form.weight >= 10000 || this.form.weight <= 400) {
          return this.$t('error.bioDataEntry.weight')
        }
      }

      return null
    },
    errorLength(){
      if (this.form.length) {
        if (this.form.length >= 150 || this.form.length <= 15) {
          return this.$t('error.bioDataEntry.length')
        }
      }

      return null
    },
  },
  data() {
    return {
      error: "",
      form: {
        firstName: "",
        lastName: "",
        birthday: "",
        crib: null,
        length: null,
        weight: null,
        externalId: null,
        selectedLocales: [],
      },
      patient: null,
      loading: false
    };
  },
  mounted() {
    const tempPatient = this.$store.getters.patient
    this.form.firstName = tempPatient.firstName
    this.form.lastName = tempPatient.lastName
    this.form.crib = tempPatient.crib
    this.form.externalId = tempPatient.externalId
    console.log("birthday", tempPatient.birthday)

    if (tempPatient.birthday && !tempPatient.birthday.includes('0001')) {
      this.form.birthday = this.$moment(tempPatient.birthday).format("YYYY-MM-DD")
    } else {
      this.form.birthday = ''
    }
    this.$refs.firstName.$el.children[1].focus();
  },
  methods: {
    getAllSupportedLocales() {
      return getSupportedLocales("all", this.$store.getters.user.language)
    },
    writePatient(action) {
      if (this.requiredFieldsFilledIn) {
        if (action !== "add") return;
        this.loading = true;

        if (action === "add") {
          // Create new
          this.consoleLog("Creating patient");

          const data = {
            emailParent1: this.form.emailParent1,
            emailParent2: this.form.emailParent2,
            patient: {
              firstName: this.form.firstName,
              lastName: this.form.lastName,
              birthday: this.form.birthday,
              crib: this.form.crib,
              length: this.form.length,
              weight: this.form.weight,
              hospitalId: this.$store.getters.user.hospital.id,
              languages: JSON.stringify(this.form.selectedLocales),
              externalId: this.form.externalId
            }
          };

          neoparentPatients
            .addPatient(data)
            .then(result => {
              this.loading = false;

              const post = {
                title: this.$store.getters.user.hospital.hospitalDefaultMessages.onWelcome.title,
                content: this.$store.getters.user.hospital.hospitalDefaultMessages.onWelcome.message,
                access: "priv",
              }

              neoparentPosts.addPost(result.data.patient.id, post)
                .then(() => {
                  this.redirect(
                    `/dashboard/nurse/${this.nurseId}/patient/${result.data.patient.id}`
                  );
                })
            })
            .catch(err => {
              this.loading = false;
              this.error = err.response.data.message;
              window.scrollTo(0, 0);
              this.consoleLog(err);
            });
        }
      } else {
        this.error = this.$t("error.policy.mandatoryFields");
        window.scrollTo(0, 0);
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
